// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1teBr","content":"styles_content__QSO95","tableWrap":"styles_tableWrap__1vh1d"};